export { default } from './EmptyPurchaseHistory';
